import { Box, IconButton, Tooltip } from '@mui/material';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import FullscreenExitIcon from '@mui/icons-material/FullscreenExit';
import { useState, useRef, useEffect } from 'react';

function Visualization() {
  const [isFullscreen, setIsFullscreen] = useState(false);
  const containerRef = useRef(null);

  const toggleFullscreen = () => {
    if (!document.fullscreenElement) {
      containerRef.current.requestFullscreen();
      setIsFullscreen(true);
    } else {
      document.exitFullscreen();
      setIsFullscreen(false);
    }
  };

  // Handle fullscreen change events
  useEffect(() => {
    const handleFullscreenChange = () => {
      setIsFullscreen(!!document.fullscreenElement);
    };

    document.addEventListener('fullscreenchange', handleFullscreenChange);
    return () => {
      document.removeEventListener('fullscreenchange', handleFullscreenChange);
    };
  }, []);

  return (
    <Box 
      ref={containerRef}
      sx={{ 
        width: '100%', 
        height: isFullscreen ? '100vh' : '700px',
        position: 'relative',
        overflow: 'hidden',
        my: isFullscreen ? 0 : 2,
        bgcolor: 'white',
        display: 'flex',
        flexDirection: 'column',
        '& #visualization-container': {
          width: '100% !important',
          height: '100% !important',
          margin: '0 !important',
          padding: '0 !important',
          display: 'flex !important'
        },
        '& #graph': {
          flex: '1 1 auto !important',
          width: 'calc(100% - 300px) !important',
          minWidth: '0 !important',
          '& svg': {
            width: '100% !important',
            height: '100% !important',
            display: 'block !important'
          }
        },
        '& #details-panel': {
          width: '300px !important',
          minWidth: '300px !important',
          flex: '0 0 300px !important'
        }
      }}
    >
      <Tooltip title={isFullscreen ? "Exit fullscreen" : "Enter fullscreen"}>
        <IconButton
          onClick={toggleFullscreen}
          size="small"
          sx={{
            position: 'absolute',
            top: 8,
            right: 8,
            zIndex: 1000,
            bgcolor: 'white',
            '&:hover': {
              bgcolor: 'rgba(255, 255, 255, 0.9)'
            }
          }}
        >
          {isFullscreen ? <FullscreenExitIcon /> : <FullscreenIcon />}
        </IconButton>
      </Tooltip>
      <Box
        sx={{
          flex: 1,
          width: '100%',
          height: '100%',
          position: 'relative',
          overflow: 'hidden'
        }}
      >
        <iframe
          src="/visualization/index.html"
          style={{
            width: '100%',
            height: '100%',
            border: 'none',
            backgroundColor: 'white',
            position: 'absolute',
            top: 0,
            left: 0
          }}
          title="Document Relationship Visualization"
          allow="fullscreen"
          sandbox="allow-same-origin allow-scripts"
        />
      </Box>
    </Box>
  );
}

export default Visualization; 